import {Component, Input, OnInit} from '@angular/core';

export interface TractorsPerDomain {
  domainID: number;
  domainName: string;
  data: { type: string, count: number }[];
}

@Component({
  selector: 'app-tractors-per-domain-widget',
  templateUrl: './tractors-per-domain-widget.component.html',
  styleUrls: ['./tractors-per-domain-widget.component.scss']
})
export class TractorsPerDomainWidgetComponent implements OnInit {

  @Input()
  data: TractorsPerDomain[];

  constructor() {
  }

  ngOnInit(): void {
  }

  customizeLabel(arg) {
    return arg.valueText; // + ' (' + arg.percentText + ')';
  }

}
